import { GENERATE_URL } from "@services/helpers/request";

const PREFIX_URL = "/CompanyIntegrationConnection";

/**
 * Firma entegrasyon bağlantısını kurar veya mevcut kaydı yeniden login eder.
 * @param {{ query?: object, params?: object }} [options]
 */
export const Connect = (options) =>
  GENERATE_URL(`${PREFIX_URL}/Connect`, options);

/**
 * Integration code için aktif bağlantı durumunu döner.
 * @param {{ query?: { integrationCode: string }, params?: object }} [options]
 */
export const GetConnectStatus = (options) =>
  GENERATE_URL(`${PREFIX_URL}/ConnectStatus`, options);

/**
 * Bağlı entegrasyon kullanıcısı / onboarding bilgisini döner.
 * @param {{ query?: object, params?: object }} [options]
 */
export const GetMe = (options) => GENERATE_URL(`${PREFIX_URL}/Me`, options);

export default {
  Connect,
  GetConnectStatus,
  GetMe,
};
